<template>
  <v-container>
    <!-- <MissingParamsDialog ref="missingParamsDialog" @mustSaveMissingParams="mustSaveMissingParams = true" /> -->
    <PageHeader icon="assignment" no-padding subtitle="Use this query tool to compile data from multiple continuous data stations. The time series will update a short time after selection." />

    <v-card>
      <v-card-actions class="card-bg-2 py-0 layout wrap">
        <!-- <v-btn class="my-2 ml-0 mr-2" style="min-width: 160px" :depressed="drawer" @click="drawer = true">
          <v-icon class="mr-2" color="info">folder_open</v-icon>
          <div class="text-capitalize">{{$t('Button.Open')}}</div>
        </v-btn>
        <v-divider v-if="$vuetify.breakpoint.mdAndUp" class="my-2 ml-1 mr-3" vertical />
        <NewQuery class="my-2 ml-0 mr-2" :confirmOnNew="hasUnsavedChanges" :disabled="!canNewQuery" @clear:query="clearQuery()" />
        <SaveQuery class="my-2 ml-0 mr-2" :query="query" :disabled="!canSave" @update:query="updateQuery($event)" :selection="selection" :reportOptions="reportOptions" />

        <v-divider v-if="$vuetify.breakpoint.mdAndUp" class="my-2 ml-1 mr-3" vertical /> -->
        <ContinuousDataDownload class="my-2 ml-0 mr-2" :disabled="!canDownload" :selection="selection" :reportOptions="reportOptions" @loading="isGeneratingReport = $event" />
      </v-card-actions>
      <v-divider />

      <v-layout>
        <!-- <SavedQueries ref="savedQueries" :confirmOnLoad="hasUnsavedChanges" @update:drawer="drawer = $event" :query="query" @load:query="loadQuery($event)" :drawer="drawer" /> -->
        <v-flex class="pt-0" style="min-width: 0;">
          <QueryHeader :class="{ 'card-border-left': drawer }" :query="query" />
          <v-divider />
          <!-- <AlertsBar class="pb-1" :mustSaveMissingParams="mustSaveMissingParams" @showMissingParams="$refs.missingParamsDialog.show()" :hasSelectedStation="hasSelectedStation" :hasSelectedAnalyte="hasSelectedTimeSeries" :hasMadeSelection="hasMadeSelection" :isQuerySaved="isQuerySaved" :hasQuery="!!query" :hasUnsavedChanges="hasUnsavedChanges" /> -->
          <v-tabs :height="32" v-model="activeTab" slider-color="info" color="transparent">
            <v-tab class="selection-tab mx-1 mt-1" :href="`#${availableTabs.parameters}`">
              Report data
            </v-tab>
            <v-tab class="selection-tab mx-1 mt-1" :href="`#${availableTabs.actions}`">
              Report options
            </v-tab>
            <v-tab-item :class="{ 'card-border-left': drawer }" :value="availableTabs.parameters">
              <v-divider />
              <v-progress-linear v-if="loading" class="position-sticky my-0" :height="10" color="info" indeterminate />
              <div v-else class="card-bg-2" style="width: 100%; height: 10px;" />
              <ViewContinuousDataQuery ref="viewQuery" style="margin-top: -10px;" :isGeneratingReport="isGeneratingReport" @update:isInitialized="isInitialized = $event" @update:loading="loadingStates = $event" @update:selection="updateSelection($event)" />
            </v-tab-item>
            <v-tab-item :value="availableTabs.actions">
              <v-divider />
              <ContinuousReportParams ref="reportParams" :disabled="loading" @update:reportOptions="reportOptions = $event" :selection="selection" />
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
  import MissingParamsDialog from './MissingParamsDialog'
  import ViewContinuousDataQuery from './ViewContinuousDataQuery'
  import ContinuousReportParams from './Parameters/ContinuousReportParams'

  import ContinuousDataDownload from './Actions/Download/ContinuousDataDownload'
  import SaveQuery from './Actions/SaveQuery/SaveQuery'
  import NewQuery from './Actions/NewQuery'

  import SavedQueries from './SavedQueries'
  import AlertsBar from './AlertsBar'
  import QueryHeader from './QueryHeader'

  const availableTabs = {
    parameters: 'params',
    actions: 'actions',
  }

  import {
    emptyQuery,
  } from '@/helpers/multiStationQuery'

  const serviceUnavailable = (context) => context.$store.dispatch('app/setSnackbar', {
    text: 'Sorry, saved queries are not available right now. Please try again in a few minutes — let us know if it happens again!',
    color: 'error',
    icon: 'error',
  })

  import {
    PING_INTERVAL,
  } from '@/store/ServiceRegistry/services'

  export default {
    components: {
      MissingParamsDialog,
      ViewContinuousDataQuery,
      ContinuousReportParams,
      ContinuousDataDownload,
      SaveQuery,
      NewQuery,
      SavedQueries,
      AlertsBar,
      QueryHeader,
    },
    data() {
      return {
        availableTabs,
        activeTab: availableTabs.parameters,

        isInitialized: false,
        reportOptions: null,
        isGeneratingReport: false,

        query: null,
        isQuerySaved: true,
        loadingStates: {},
        selection: null,
        drawer: false,
        search: '',

        mustSaveMissingParams: false,

        headers: [{
          text: 'Name',
          value: 'name',
          align: 'left',
        },
        {
          text: 'Description',
          value: 'description',
          align: 'left',
        },
        {
          text: 'Last updated',
          value: 'lastUpdated',
          align: 'left',
        },
        {
          text: 'Actions',
          value: '',
          sortable: false,
          align: 'center',
        },
        ],
        pingTimeoutId: null,
      }
    },
    computed: {
      isServiceActive() {
        return true
        //return this.$store.getters['multistation/isServiceActive']
      },
      missingParams() {
        return this.$store.getters['multistation/missingParams']
      },
      hasSelectedTimeSeries() {
        return this.selection && this.selection.timeSeries && this.selection.timeSeries.length > 0
      },
      hasSelectedStation() {
        return this.selection && this.selection.stations && this.selection.stations.length > 0
      },
      hasMadeSelection() {
        return this.hasSelectedTimeSeries
      },
      canDownload() {
        console.log('can select time series : ' + this.hasSelectedTimeSeries)
        return this.isServiceActive && this.hasSelectedTimeSeries && !this.loading
      },
      canSave() {
        return this.isServiceActive && this.hasSelectedTimeSeries && !this.loading
      },
      canNewQuery() {
        return !this.loading
      },
      loading() {
        return Object.values(this.loadingStates).some(isLoading => isLoading) || !this.isInitialized
      },
      hasUnsavedChanges() {
        return this.isServiceActive && this.hasMadeSelection && !this.isQuerySaved || this.mustSaveMissingParams
      },
    },
    watch: {
      missingParams() {
        this.mustSaveMissingParams = false
      },
    },
    methods: {
      pingService() {
        if (this.pingTimeoutId) return

        let ping = () => {
          this.$store.dispatch('multistation/pingService')
        }

        ping()
        this.pingTimeoutId = setInterval(ping, PING_INTERVAL)
      },
      updateSelection(selection) {
        this.selection = selection

        if (!this.isInitialized || this.loadingStates.selection) return
        this.isQuerySaved = false
      },
      updateQuery(query) {
        this.isQuerySaved = true
        this.mustSaveMissingParams = false
        this.query = query
        this.$refs.savedQueries.fetchQueries()
      },
      async clearQuery() {
        await this.loadQuery(emptyQuery)
        this.query = null
      },
      async fetchReportGenerator() {
        try {
          await this.$store.dispatch('multistation/fetchReportGenerator')
          this.pingService()
        } catch (error) {
          serviceUnavailable()
        }
      },
      async loadQuery(query) {
        if (this.loadingStates.selection) return
        this.isQuerySaved = true
        this.query = query

        const {
          selection,
          reportOptions,
        } = query.queryParams

        const selectionOptions = {
          relativeDate: query.relativeDate,
        }

        await this.$nextTick()
        this.$refs.reportParams.loadReportOptions(reportOptions)
        await this.$refs.viewQuery.loadSelection(selection, selectionOptions)
      },
    },
    created() {
      this.fetchReportGenerator()
    },
    beforeDestroy() {
      clearTimeout(this.pingTimeoutId)
    },
  }
</script>

<style>
  .max-width {
    width: 100%;
  }

  .scroll-border-bottom {
    border-bottom-color: #ddd !important;
  }

  .align-button-checkbox {
    padding-left: 14px !important;
  }

  .align-button-checkbox>.v-btn:hover:before {
    background-color: transparent !important;
  }

  .align-button-checkbox-list {
    padding-left: 0px !important;
  }

  .align-button-checkbox-list>.v-btn {
    width: 22px;
    margin-right: 10px !important;
  }

  .align-button-checkbox-list>.v-btn:hover:before {
    background-color: transparent !important;
  }

  .selection-tab {
    background: #ddd;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border: 1px solid rgba(0, 0, 0, .12);
  }
</style>